import { HarvestTypes } from "@gtpl/shared-models/common-models";
import { CompanyCategoryEnum } from "./company-category";

export class RmCountPriceListDto{
    rmratesId:number
    // minValue:number
    // maxValue:number
    count:number
    price:number
    isActive: boolean;
    createdUser: string;
    updatedAt: Date;
    createdAt:Date;
    updatedUser: string;
    versionFlag: number;
    company:string
    type: HarvestTypes;
    category?:CompanyCategoryEnum
    constructor(
        rmratesId:number,
        // minValue:number,
        // maxValue:number,
        count:number,
        price:number,
        isActive: boolean,
        createduser:string,
        updatedAt: Date,
        updateuser:string,
        versionflag:number,
        createdAt:Date,
        company:string,
        type:HarvestTypes,
    category?:CompanyCategoryEnum
    ){
        this.rmratesId=rmratesId
        // this.minValue=minValue
        // this.maxValue=maxValue
        this.count=count
        this.price=price
        this.isActive=isActive
        this.createdUser=createduser
        this.updatedAt=updatedAt
        this.updatedUser=updateuser
        this.versionFlag=versionflag
        this.createdAt=createdAt
        this.category = category
        this.company = company
        this.type = type
    }
}

export class RmCountPriceListRequestDto{
    data:RmCountPriceListDto[]
    user:string
    constructor(
        data:RmCountPriceListDto[],
    user:string
    ){
        this.data = data
        this.user = user
    }
}